// libs
import React, { memo, useState } from 'react';

// anlaytics
import { trackCollapsibleSectionClicked } from 'shared/layouts/DetailsPage/analytics';

// icons

import BoxIcon from '@nykaa/ui-components/Icons/box';
import AlertInfoIcon from '@nykaa/ui-components/Icons/alert-info';
import AccountMoreIcon from '@nykaa/ui-components/Icons/account-more';
import CircleExchangeIcon from '@nykaa/ui-components/Icons/circle-exchange';

// styles
import {
  Container,
  HeaderIconContainer,
  Title,
  Header,
  Subtitle,
  HeaderContainer,
  EmptyIconPlaceHolder,
} from './styles';

// defs
interface ICollapsibleHeader {
  isExpanded: boolean;
  title: string;
  subtitle: string;
  iconName: string;
}

function CollapsibleHeader({ isExpanded, title, subtitle, iconName }: ICollapsibleHeader) {
  const [headerClickedOnced, setHeaderClickedOnced] = useState(false);

  const onHeaderClicked = (expanded: boolean) => {
    if (!headerClickedOnced && expanded === false) {
      trackCollapsibleSectionClicked(title);
      setHeaderClickedOnced(true);
    }
  };

  const getHeaderIcon = (icon: string) => {
    switch (icon) {
      case 'icon-box':
        return <BoxIcon />;
      case 'icon-information':
        return <AlertInfoIcon />;
      case 'icon-bn-account':
        return <AccountMoreIcon />;
      case 'icon-circle-exchange':
        return <CircleExchangeIcon />;
      default:
        return <EmptyIconPlaceHolder />;
    }
  };

  return (
    <Container data-test="container-test" onClick={() => onHeaderClicked(isExpanded)}>
      <HeaderContainer isExpanded={isExpanded} data-test="hc-test">
        <HeaderIconContainer>{getHeaderIcon(iconName)}</HeaderIconContainer>
        <Header isExpanded={isExpanded}>
          <Title data-at="product-info">{title}</Title>
          {!isExpanded && <Subtitle>{subtitle}</Subtitle>}
        </Header>
      </HeaderContainer>
    </Container>
  );
}

export default memo(CollapsibleHeader);
